module.exports = {
  mon: {
    key: 'mon',
    label: 'Monday',
  },
  tues: {
    key: 'tues',
    label: 'Tuesday',
  },
  wed: {
    key: 'wed',
    label: 'Wednesday',
  },
  thu: {
    key: 'thu',
    label: 'Thursday',
  },
  fri: {
    key: 'fri',
    label: 'Friday',
  },
  sat: {
    key: 'sat',
    label: 'Saturday',
  },
  sun: {
    key: 'sun',
    label: 'Sunday',
  },
};